import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainDatatable from "../../../components/datatable/MainDatatable.jsx";
import * as AstrologerActions from "../../../redux/actions/astrologerAction";
import { DeleteSvg, EditSvg } from "../../../assets/svg/index.js";
import { DeepSearchSpace } from "../../../utils/common-function/index.js";
import DatatableHeading from "../../../components/datatable/DatatableHeading.jsx";
import { Chip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, Typography, Divider, IconButton, Tooltip } from "@mui/material";
import { Visibility as ViewIcon } from "@mui/icons-material";

const AstrologerEnquiry = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { enquiryAstrologerData } = useSelector(state => state?.astrologerReducer);
    const [searchText, setSearchText] = useState("");
    const [selectedAstrologer, setSelectedAstrologer] = useState(null);
    const [detailsOpen, setDetailsOpen] = useState(false);
    const filteredData = DeepSearchSpace(enquiryAstrologerData, searchText);

    const columns = [
        { name: "S.No.", selector: (row, index) => enquiryAstrologerData.indexOf(row) + 1, width: "70px" },
        { name: "Name", selector: (row) => row?.astrologerName, width: "130px" },
        { name: "Mobile", selector: (row) => row?.phoneNumber, width: "120px" },
        { name: "City", selector: (row) => row?.city || "N/A", width: "100px" },
        { name: "State", selector: (row) => row?.state || "N/A", width: "100px" },
        { name: "Experience", selector: (row) => row?.experience ? row?.experience + " yrs" : "N/A", width: "100px" },
        { 
            name: "Expertise", 
            selector: (row) => { 
                const e = row?.expertise || row?.specialization || []; 
                return Array.isArray(e) ? e.slice(0,2).join(", ") : e || "N/A"; 
            }, 
            width: "140px" 
        },
        { name: "Education", selector: (row) => row?.education || "N/A", width: "120px" },
        { 
            name: "Status", 
            cell: (row) => { 
                const s = row?.status || "Pending"; 
                let c = "warning"; 
                if(s === "Approved") c = "success"; 
                else if(s === "Rejected") c = "error"; 
                return <Chip label={s} color={c} size="small" />; 
            }, 
            width: "100px" 
        },
        { name: "Applied On", selector: (row) => moment(row?.createdAt).format("DD MMM YY"), width: "100px" },
        { 
            name: "Action", 
            cell: (row) => (
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <Tooltip title="View Details">
                        <IconButton size="small" onClick={() => handleViewDetails(row)} color="info">
                            <ViewIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                    <div onClick={() => navigate("/astrologer/edit-astrologer", { state: { stateData: row } })} style={{ cursor: "pointer" }}>
                        <EditSvg />
                    </div>
                </div>
            ), 
            center: true, 
            width: "100px" 
        },
    ];

    const handleViewDetails = (astrologer) => { 
        setSelectedAstrologer(astrologer); 
        setDetailsOpen(true); 
    };

    useEffect(function () { 
        dispatch(AstrologerActions.getEnquiryAstrologer()); 
    }, []);

    return (
        <>
            <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: "0px 0px 5px lightgrey", borderRadius: "10px" }}>
                <DatatableHeading title={"Astrologer Enquiry"} data={enquiryAstrologerData} />
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "20px", alignItems: "center", marginBottom: "20px", backgroundColor: "#fff" }}>
                    <input 
                        type="search" 
                        value={searchText} 
                        onChange={(e) => setSearchText(e.target.value)} 
                        placeholder="Search your data..." 
                        style={{ padding: "5px 10px", borderRadius: "5px", border: "1px solid #ccc", boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)", width: "100%", maxWidth: "250px", fontSize: "15px", outline: "none" }} 
                    />
                </div>
                <MainDatatable columns={columns} data={filteredData} />
            </div>
            
            {/* Astrologer Details Dialog */}
            <Dialog open={detailsOpen} onClose={() => setDetailsOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle sx={{ bgcolor: "#f5f5f5" }}>
                    <Typography variant="h6">Astrologer Enquiry Details</Typography>
                </DialogTitle>
                <DialogContent sx={{ mt: 2 }}>
                    {selectedAstrologer && (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Divider sx={{ mb: 2 }}>Personal Information</Divider>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <Typography variant="subtitle2" color="textSecondary">Name</Typography>
                                <Typography variant="body1">{selectedAstrologer.astrologerName || "N/A"}</Typography>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <Typography variant="subtitle2" color="textSecondary">Email</Typography>
                                <Typography variant="body1">{selectedAstrologer.email || "N/A"}</Typography>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <Typography variant="subtitle2" color="textSecondary">Mobile</Typography>
                                <Typography variant="body1">{selectedAstrologer.phoneNumber || "N/A"}</Typography>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <Typography variant="subtitle2" color="textSecondary">Date of Birth</Typography>
                                <Typography variant="body1">{selectedAstrologer.dateOfBirth ? moment(selectedAstrologer.dateOfBirth).format("DD MMM YYYY") : "N/A"}</Typography>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <Typography variant="subtitle2" color="textSecondary">City</Typography>
                                <Typography variant="body1">{selectedAstrologer.city || "N/A"}</Typography>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <Typography variant="subtitle2" color="textSecondary">State</Typography>
                                <Typography variant="body1">{selectedAstrologer.state || "N/A"}</Typography>
                            </Grid>
                            
                            <Grid item xs={12}>
                                <Divider sx={{ my: 2 }}>Professional Information</Divider>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <Typography variant="subtitle2" color="textSecondary">Experience</Typography>
                                <Typography variant="body1">{selectedAstrologer.experience ? selectedAstrologer.experience + " years" : "N/A"}</Typography>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <Typography variant="subtitle2" color="textSecondary">Education</Typography>
                                <Typography variant="body1">{selectedAstrologer.education || "N/A"}</Typography>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <Typography variant="subtitle2" color="textSecondary">Status</Typography>
                                <Chip 
                                    label={selectedAstrologer.status || "Pending"} 
                                    color={selectedAstrologer.status === "Approved" ? "success" : selectedAstrologer.status === "Rejected" ? "error" : "warning"} 
                                    size="small" 
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="subtitle2" color="textSecondary">Expertise/Specialization</Typography>
                                <Typography variant="body1">
                                    {(() => { 
                                        const e = selectedAstrologer.expertise || selectedAstrologer.specialization || []; 
                                        return Array.isArray(e) ? e.join(", ") : e || "N/A"; 
                                    })()}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="subtitle2" color="textSecondary">Bio/About</Typography>
                                <Typography variant="body1">{selectedAstrologer.bio || selectedAstrologer.about || "N/A"}</Typography>
                            </Grid>
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions sx={{ p: 2, gap: 1 }}>
                    <Button onClick={() => setDetailsOpen(false)} variant="outlined">Close</Button>
                    <Button 
                        onClick={() => navigate("/astrologer/edit-astrologer", { state: { stateData: selectedAstrologer } })} 
                        variant="contained" 
                        color="primary"
                    >
                        Edit Astrologer
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default AstrologerEnquiry;
